import { Flex, SelectInput, VStack, Widget } from '@revolut-internal/ui-kit'
import { Panel, PanelGroup } from 'react-resizable-panels'
import { useRef } from 'react'

import { LocalStorageKeys } from 'lib/shared/consts'
import { ErrorWidget, NotFoundWidget } from 'components'
import { usePrompt } from 'pages/AiProcessDebug/providers/PromptProvider'
import { NotFoundError, VoicebotNotInvolvedError } from 'lib/apiClient'

import { DialogueSnapshot } from '../DialogueSnapshot'
import { Trace } from '../Trace'
import { ResizeHandle } from './ResizeHandle'

const PANEL_MIN_SIZE = 37.5
const PAGE_BOTTOM_PADDING_PX = 16

export const MessageDebug = () => {
  const widgetRef = useRef<HTMLDivElement>(null)

  const { processOptions, generalError, selectedProcess, setSelectedProcess } =
    usePrompt()

  if (generalError) {
    let errorContent

    if (generalError instanceof VoicebotNotInvolvedError) {
      errorContent = <NotFoundWidget title="Voicebot was not involved in the call" />
    } else if (generalError instanceof NotFoundError) {
      errorContent = (
        <NotFoundWidget
          title="AI debug traces not found"
          description={
            typeof generalError?.cause === 'string' ? generalError.cause : undefined
          }
        />
      )
    } else {
      errorContent = <ErrorWidget />
    }

    return (
      <Flex
        alignItems="center"
        justifyContent="center"
        width="100%"
        minWidth="960px"
        height="calc(100vh - 32px)"
      >
        {errorContent}
      </Flex>
    )
  }

  const widgetOffsetTop = widgetRef.current?.offsetTop ?? 0

  return (
    <VStack space="s-16" width="100%" overflow="auto" height="100%">
      <Flex minWidth="320px" ml="auto">
        <SelectInput
          label="AI process"
          searchable={false}
          disabled={processOptions.length < 2}
          value={selectedProcess}
          onChange={value => {
            value && setSelectedProcess(value)
          }}
          options={processOptions}
        />
      </Flex>
      <Widget
        ref={widgetRef}
        height={`calc(100vh - ${widgetOffsetTop}px - ${PAGE_BOTTOM_PADDING_PX}px)`}
        minWidth="960px"
        borderRadius="popup"
      >
        <PanelGroup
          direction="horizontal"
          autoSaveId={LocalStorageKeys.MESSAGE_DEBUG_PANELS}
        >
          <Panel minSize={PANEL_MIN_SIZE} defaultSize={PANEL_MIN_SIZE}>
            <DialogueSnapshot />
          </Panel>
          <ResizeHandle />
          <Panel minSize={PANEL_MIN_SIZE}>
            <Trace />
          </Panel>
        </PanelGroup>
      </Widget>
    </VStack>
  )
}
